require('./index.scss');
import { Component } from 'preact';
import { route } from 'preact-router';
//import Fullscreen from "../helper/fullscreen";

let elem = {
    x: 0,
    y: 900,
    width: 100,
    height: 100,
    name:'player 1',
    fill: '#BADA55',
    pos:1
}
let elem2 = {
    x: 0,
    y: 900,
    name:'player 2',
    width: 100,
    height: 100,
    fill: '#BADA55',
    pos:1
}

const BASE_PATH = '';//'/dinosaurs-doing-stuff'

const Fullscreen = f => f;

class BoardGame extends Component {
    state = { error: false, hasWon:false, loading:false, players:[], isFull: false};
    goFull = () =>{
        this.setState({ isFull: true });
    }
    loadImages(){
        let {images} = this.state.game.data || {};
        if(!images) return;

        images.forEach(img => {
            img.img = new Image();
            img.img.onload = ()=>{
                img.loaded = true;
                console.log(img.img,'loaded');
                let newState = {game:Object.assign(this.state.game,{data:{images}})};
                this.setState({
                    newState
                });
                let loadingImages = images.filter(i => !i.loaded).length > 0;
                this.setState({loading:loadingImages});
            };
            img.img.src = BASE_PATH + '/assets/boardgame/' + img.src;
        });
    };
    imageByName(name){
        let {images} = this.state.game.data || {};
        return images.find(i => i.name === name);
    }
    componentWillUpdate(props,state){
        console.log('componentWillUpdate',state);
        const {data} = state.game;
        let loadingImages = data.images.filter(i => !i.loaded).length;

        if(!state.game || state.loading){
            return;
        }
        if(document.getElementById("canvas_game") && !this.ctx){
            this.ctx = document.getElementById("canvas_game").getContext("2d");
            console.log('yes canvas');
        } else {
            console.log('no canvas')
        }
        if(!loadingImages && this.ctx){
            this.animloop();
        };
    }
    animate(){
        let {players} = this.state.players;
        if(this.ctx){
            console.log('anim');
            this.ctx.clearRect( 0, 0, 1000, 1000 );
            this.ctx.drawImage(this.imageByName('bg').img, 0, 0, 1200, 1200, 0,0,1000,1000);
            this.ctx.drawImage(this.imageByName('foreground').img, 0, 0, 1200, 1200, 0,0,1000,1000);
            //ctx.fillRect( elem.x, elem.y, elem.width, elem.height );
            this.ctx.drawImage(this.imageByName('pirate').img, 0, 0, 120, 120, elem.x+10, elem.y+10,80,80);
            this.ctx.drawImage(this.imageByName('hero').img, 0, 0, 120, 120, elem2.x+10, elem2.y+10,80,80);
        }
    }
    requestAnimFrame = ()=>{
        return  window.requestAnimationFrame       ||
            window.webkitRequestAnimationFrame ||
            window.mozRequestAnimationFrame    ||
            function( callback ){
                window.setTimeout(callback, 1000 / 60);
            };
    };
    animloop(){
        console.log('animloop');
        this.requestAnimFrame(this.animloop);
        this.animate();
    };
    componentWillMount(props){
        if(typeof window !== 'undefined'){
          window.scrollTo(0, 0)
        }
        if(this.props.matches && this.props.matches['activity-id']){
            this.setState({loading:true});
            fetch(BASE_PATH + '/assets/boardgame/' + this.props.matches['activity-id'] + '.json')
                .then(function(response) {
                    return response.json();
                })
                .then((gameJSON) =>{
                    this.setState({game:gameJSON, loading:'Loading Images'});
                    this.loadImages();
                }).catch((error)=>{
                    this.setState({error:"Bad Bundle"});
            })
        } else {
            this.setState({error:"No Bundle"})
        }
    };
    render(){
        const {data} = this.state.game || {};
        const {toptext, bottomtext} = this.state.spot || {};
        return (
            <div className="board-game">
                {this.state.error && (<h1>Error {this.state.error}</h1>)}
                {this.state.loading && (<h1>Loading</h1>)}
                <p dangerouslySetInnerHTML={{__html: toptext}}/>
                <Fullscreen
                    enabled={this.state.isFull}
                    onChange={isFull => this.setState({isFull})}
                >
                    <div className="game__wrapper">
                        <div className={'game__canvas'}>
                            <canvas id="canvas_game" width="1000" height="1000"/>
                        </div>
                    </div>
                </Fullscreen>

                <p dangerouslySetInnerHTML={{__html: bottomtext}}/>
                {/*<button onClick={this.goFull}>
                    Go Fullscreen
                </button>
                */}
            </div>
        )
    }
}

export default BoardGame;



// WEBPACK FOOTER //
// ./components/boardgame/index.js